var uiKit = {
  datepicker: {
    sunday: 'Κυριακή',
    monday: 'Δευτέρα',
    tuesday: 'Τρίτη',
    wednesday: 'Τετάρτη',
    thursday: 'Πέμπτη',
    friday: 'Παρασκευή',
    saturday: 'Σάββατο',
    sunday_short: 'ΚΥ',
    monday_short: 'ΔΕ',
    tuesday_short: 'ΤΡ',
    wednesday_short: 'ΤΕ',
    thursday_short: 'ΠΕ',
    friday_short: 'ΠΑ',
    saturday_short: 'ΣΑ',
    january: 'Ιανουάριος',
    february: 'Φεβρουάριος',
    march: 'Μάρτιος',
    april: 'Απρίλιος',
    may: 'Μάιος',
    june: 'Ιούνιος',
    july: 'Ιούλιος',
    august: 'Αύγουστος',
    september: 'Σεπτέμβριος',
    october: 'Οκτώβριος',
    november: 'Νοέμβριος',
    december: 'Δεκέμβριος',
    pick_year: 'Επιλέξτε έτος',
    pick_month: 'Επιλέξτε μήνα',
    pick_date: 'Επιλέξτε ημερομηνία'
  }
};

export default {
  myaccount: {
    welcomeBar: {
      hi: 'Γεια',
      lastLogin: 'Τελευταία σύνδεση',
      fullDate: '{{year}}-{{month}}-{{day}} {{hour}}',
      months: {
        '01': '01',
        '02': '02',
        '03': '03',
        '04': '04',
        '05': '05',
        '06': '06',
        '07': '07',
        '08': '08',
        '09': '09',
        10: '10',
        11: '11',
        12: '12'
      }
    },
    accountInfo: {
      id: 'Αναγνωριστικό Λογαριασμού'
    },
    navigationMenu: {
      title: {
        myBets: 'Τα Στοιχήματά Μου',
        accountHistory: 'Ιστορικό Λογαριασμού',
        withdraw: 'Ανάληψη',
        reversalWithdraw: 'Αντίστροφη Ανάληψη',
        myRewards: 'Οι Ανταμοιβές Μου',
        myAccount: 'Ο Λογαριασμός Μου',
        depositLimit: 'Όριο κατάθεσης',
        deposit: 'Κατάθεση',
        gamblingControls: 'Ρυθμίση Πονταρίσματος',
        saferGambling: 'Ασφαλέστερος Τζόγος',
        pokerBalanceTransfer: 'Balance Transfer'
      }
    },
    profitAndLoss: {
      title: 'Κέρδος και ζημία',
      description: {
        up: 'Είστε {{value}} πάνω αυτό τον μήνα',
        down: 'Είστε {{value}} κάτω αυτό τον μήνα'
      }
    },
    myAccountTitles: {
      title: {
        accountHistory: 'Ιστορικό Λογαριασμού',
        personalDetails: 'Προσωπικά Στοιχεία',
        loginSecuritySettings: 'Ρυθμίσεις Σύνδεσης & Ασφάλειας',
        siteSettings: 'Ρυθμίσεις Ιστότοπου'
      },
      listItems: {
        statementsView: 'Προβολή Καταθέσεων',
        summaries: 'Πληροφορίες Καθαρής Κατάθεσης',
        contactName: 'Όνομα Επαφής',
        contactDetails: 'Στοιχεία Επικοινωνίας',
        marketingPreferences: 'Προτιμήσεις Μάρκετινγκ',
        autoLogin: 'Αυτόματη σύνδεση',
        twoFactorAuth: 'Πιστοποίηση δύο παραγόντων',
        password: 'Κωδικός πρόσβασης',
        oddsFormat: 'Μορφή αποδόσεων',
        movementPrices: 'Τιμές κίνησης'
      }
    },

    saferGambling: {
      tilesConfig: {
        header: {
          text: 'Τα τυχερά παιχνίδια πρέπει πάντα να είναι διασκεδαστικά. Έτσι, δημιουργήσαμε μερικά χρήσιμα εργαλεία για να σας βοηθήσουμε να διατηρήσετε τον έλεγχο των ποσών που ξοδεύετε.'
        },

        footer: {
          text: 'Μάθετε περισσότερα για το τι κάνουμε για να υποστηρίξουμε το να παίζετε ',
          link: 'Ασφαλέστερος Τζόγος'
        },
        depositLimits: {
          title: 'Όρια Καταθέσεων',
          description: 'Ορίστε κυλιόμενα ημερήσια, εβδομαδιαία ή μηνιαία όρια για το μέγιστο χρηματικό ποσό που μπορείτε να καταθέσετε στον λογαριασμό σας'
        },

        gamingTimeReminder: {
          title: 'Υπενθύμιση χρόνου παιχνιδιού',
          description: 'Διατίθεται μόνο σε προϊόντα παιχνιδιών. Ρυθμίστε ειδοποιήσεις που σας ενημερώνουν για το πόση ώρα παίζετε.'
        },

        timeOut: {
          title: 'Διάλειμμα',
          descriptionUk: 'Κάντε ένα διάλειμμα από τα τυχερά παιχνίδια μαζί μας. Μπορεί να είναι έως και 42 ημέρες.',
          descriptionNonUk: 'Κάντε ένα διάλειμμα από το στοίχημα σε εμάς. Μπορεί να είναι οποιοδήποτε διάστημα έως και 6 μήνες.'
        },

        accountClosure: {
          title: 'Κλείσιμο λογαριασμού',
          description: 'Λυπούμαστε που σας βλέπουμε να αποχωρείτε, αλλά αν θέλετε να κλείσετε τον λογαριασμό σας, μπορείτε να το κάνετε εδώ.'
        },

        selfExclusion: {
          title: 'Αυτοαποκλεισμός',
          description: 'Κλείστε τον λογαριασμό σας για έξι μήνες έως πέντε χρόνια.'
        },
        profitAndLoss: {
          title: 'Κέρδος και ζημία',
          description: {
            up: 'Είστε {{value}} πάνω αυτό τον μήνα',
            down: 'Είστε {{value}} κάτω αυτό τον μήνα'
          }
        }
      },
      views: {
        depositLimits: {
          day: 'ημέρα',
          week: 'εβδομάδα',
          month: 'μήνας',
          viewHeader: {
            title: 'Ορίστε ένα όριο κατάθεσης',
            content: 'Ορίστε ημερήσια, εβδομαδιαία ή μηνιαία όρια για το ποσό που μπορείτε να καταθέσετε.<br>' + '<a href="https://williamhill-lang-gr.custhelp.com/app/answers/detail/a_id/6003" rel="noopener noreferrer" target="_blank">Πώς γίνεται αυτό?</a>'
          },
          limits: {
            daily: 'Ημερήσιο όριο',
            weekly: 'Εβδομαδιαίο όριο',
            monthly: 'Μηνιαίο όριο'
          },
          periods: {
            day: 'ημερήσιο',
            week: 'εβδομαδιαίο',
            month: 'μηνιαίο'
          },
          buttonText: 'Αποθηκεύστε τα όρια κατάθεσής σας',
          chooseLimit: 'Επιλέξτε όριο',
          valueNotSet: 'Δεν έχει οριστεί',
          noLimit: 'Κανένα όριο',
          noLimitSet: 'Δεν έχει οριστεί όριο',
          remainingDeposit: {
            day: 'Έχουν απομείνει {{amount}} για να καταθέσετε στις ημέρα',
            week: 'Έχουν απομείνει {{amount}} για να καταθέσετε στις εβδομάδα',
            month: 'Έχουν απομείνει {{amount}} για να καταθέσετε στις μήνας'
          },
          emptyRemainingDeposit: 'Δεν έχετε όρια κατάθεσης',
          successMessage: 'Τα Όρια Κατάθεσης ενημερώθηκαν με επιτυχία',
          confirmationButton: 'Επιβεβαίωση Αύξησης Ορίου σε {{amount}}',
          confirmationButtonNoLimit: 'Επιβεβαίωση Αύξησης Ορίου σε "κανένα όριο"',
          confirmationMessage: {
            day: 'Το ημερήσιο όριό σας των {{amount}} θα είναι διαθέσιμο για επιβεβαίωση στις {{date}} στις {{time}} (ώρα Αγγλίας).<br>' + 'Μπορείτε να το ακυρώσετε <a href="#">κάνοντας κλικ εδώ</a>',
            week: 'Το εβδομαδιαίο όριό σας των {{amount}} θα είναι διαθέσιμο για επιβεβαίωση στις {{date}} στις {{time}} (ώρα Αγγλίας).<br>' + 'Μπορείτε να το ακυρώσετε <a href="#">κάνοντας κλικ εδώ</a>',
            month: 'Το μηνιαίο όριό σας των {{amount}} θα είναι διαθέσιμο για επιβεβαίωση στις {{date}} στις {{time}} (ώρα Αγγλίας).<br>' + 'Μπορείτε να το ακυρώσετε <a href="#">κάνοντας κλικ εδώ</a>'
          },
          confirmationMessageNoLimit: {
            day: 'Το ημερήσιο όριό σας των "κανένα όριο" θα είναι διαθέσιμο για επιβεβαίωση στις {{date}} στις {{time}} (ώρα Αγγλίας).<br>' + 'Μπορείτε να το ακυρώσετε <a href="#">κάνοντας κλικ εδώ</a>',
            week: 'Το εβδομαδιαίο όριό σας των "κανένα όριο" θα είναι διαθέσιμο για επιβεβαίωση στις {{date}} στις {{time}} (ώρα Αγγλίας).<br>' + 'Μπορείτε να το ακυρώσετε <a href="#">κάνοντας κλικ εδώ</a>',
            month: 'Το μηνιαίο όριό σας των "κανένα όριο" θα είναι διαθέσιμο για επιβεβαίωση στις {{date}} στις {{time}} (ώρα Αγγλίας).<br>' + 'Μπορείτε να το ακυρώσετε <a href="#">κάνοντας κλικ εδώ</a>'
          },
          confirmationSuccessful: 'Το Όριο Κατάθεσης ενημερώθηκε με επιτυχία',
          increaseWarning: 'Θα πρέπει να επιβεβαιώσετε σε 24 ώρες εάν θέλετε να αυξήσετε το όριό σας.',
          footerContent: 'Δεν βλέπετε το όριο που θέλετε να ορίσετε;<br/>' + '<a href="https://williamhill-lang-gr.custhelp.com/app/ask" rel="noopener noreferrer" target="_blank">Επικοινωνήστε με την εξυπηρέτηση πελατών</a>',
          cancellationModalContent: 'Είστε βέβαιοι ότι θέλετε να ακυρώσετε την αύξηση του ορίου κατάθεσης;'
        },

        gamingTimeReminder: {
          accordionText: 'Υπενθύμιση χρόνου παιχνιδιού',
          currentReminder: 'Τρέχουσα Υπενθύμιση:',
          reminders: {
            placeholder: 'Επιλέξτε Χρονική Περίοδο',
            noReminder: 'Χωρίς Υπενθύμιση',
            minutes: '{{time}} λεπτά',
            hour: '{{time}} ώρα',
            hours: '{{time}} ώρες'
          },
          submitButton: 'Αποθηκεύστε την Υπενθύμισή Σας',
          warningMessage: 'Η υπενθύμιση χρόνου θα τεθεί σε ισχύ όταν η τρέχουσα υπενθύμιση αυτής της περιόδου ολοκληρωθεί ή τα ενεργά παιχνίδια κλείσουν.',
          successMessage: 'Η Υπενθύμιση Χρόνου Παιχνιδιού ενημερώθηκε με επιτυχία',
          viewHeader: {
            title: 'Ορίστε Υπενθύμιση Χρόνου Παιχνιδιού',
            content: '<p>Ορίστε μια αυτόματη υπενθύμιση που θα σας ενημερώνει για πόση ώρα παίζετε.</p><a href="https://williamhill-lang-gr.custhelp.com/app/answers/detail/a_id/5939#restrict_account" rel="noopener noreferrer" target="_blank">Πώς γίνεται αυτό?</a></br></br>' + '<p>Αυτό είναι διαθέσιμο μόνο για τα προϊόντα παιχνιδιών. Παρακαλούμε σημειώστε ότι τα προϊόντα παιχνιδιών δεν περιλαμβάνουν τα αθλήματα, το πόκερ και τα τουρνουά εικονικών ή δωρεάν παιχνιδιών. Για να ορίσετε μια υπενθύμιση για περιεχόμενο της Evolution Gaming, ξεκινήστε ένα παιχνίδι, επιλέξτε "Ρυθμίσεις" και μετά "Ρυθμίσεις Συνεδρίας Παιχνιδιού".</p>'
          },
          valueNotSet: 'Δεν έχει οριστεί'
        },

        timeOut: {
          viewHeader: {
            title: 'Ορίστε διάλειμμα',
            contentUk: 'Αν θέλετε να κάνετε ένα διάλειμμα από τον στοιχιματισμό μαζί μας. Μπορούμε να ρυθμίσουμε ένα χρονικό όριο έως και 42 ημέρες.</br>' + '<a href="https://williamhill-lang-gr.custhelp.com/app/answers/detail/a_id/5939#restrict_account" rel="noopener noreferrer" target="_blank">Πώς γίνεται αυτό?</a>',
            contentNonUk: 'Αν θέλετε να κάνετε ένα διάλειμμα από τα στοιχήματα σε εμάς. Μπορούμε να ρυθμίσουμε ένα χρονικό όριο για έως και 6 μήνες.</br>' + '<a href="https://williamhill-lang-gr.custhelp.com/app/answers/detail/a_id/5939#restrict_account" rel="noopener noreferrer" target="_blank">Πώς γίνεται αυτό?</a>'
          },
          formLabel: 'Πόσο χρόνο χρειάζεστε;',
          values: {
            placeholder: 'Επιλέξτε τη διάρκεια του χρονικού ορίου',
            day: '1 ημέρα',
            days: '{{amount}} ημέρες',
            valueNotSet: 'Χωρίς διάλειμμα'
          },
          formHeader: 'Κλείστε τον λογαριασμό σας',
          passwordPlaceholder: 'Εισάγετε κωδικό πρόσβασης',
          submitButton: 'Αποθήκευση Διαλείμματός σας',
          viewFooter: 'Εάν θέλετε να ζητήσετε ένα Διάλειμμα για περισσότερες από 30 ημέρες παρακαλούμε <a href="https://williamhill-lang-gr.custhelp.com/app/ask" rel="noopener noreferrer" target="_blank">επικοινωνήστε με την εξυπηρέτηση πελατών</a>',
          resultPage: {
            title: 'Ο Λογαριασμός σας βρίσκεται σε Διάλειμμα',
            information: 'Δεν θα έχετε πρόσβαση στον λογαριασμό σας για {{period}} ημέρα(-ες).',
            helpSectionMainText: 'Για να κάνετε ένα σωστό διάλειμμα, θα πρέπει να αφαιρέσετε όλες τις εφαρμογές τυχερών παιχνιδιών και από το κινητό σας τηλέφωνο. Περισσότερες λεπτομέρειες μπορείτε να βρείτε στη σελίδα βοήθειας Υπεύθυνου τζόγου.'
          }
        },

        accountClosure: {
          header: 'Ναι, θέλω να κλείσω τον λογαριασμό μου',
          listTitle: 'Να τι πρέπει να γνωρίζετε:',
          firstListElement: 'Εάν θέλετε να κάνετε ένα διάλειμμα ή να κλείσετε τον λογαριασμό σας για λόγους SaferGambling, σκεφτείτε ένα <a href="https://williamhill-lang-gr.custhelp.com/app/answers/detail/a_id/5939#restrict_account" rel="noopener noreferrer" target="_blank">χρονικό όριο</a> (έως 6 εβδομάδες) ή έναν <a href="https://williamhill-lang-gr.custhelp.com/app/answers/detail/a_id/5939" rel="noopener noreferrer" target="_blank">αυτοαποκλεισμό</a> (έως πέντε χρόνια)',
          secondListElement: 'Φροντίστε πρώτα να κάνετε ανάληψη των υπόλοιπων των χρημάτων από τον λογαριασμό σας',
          thirdListElement: 'Παρακαλούμε λάβετε υπόψη ότι θα κρατήσουμε τα δεδομένα σας για τουλάχιστον 5 χρόνια, παρακαλούμε δείτε την <a href="https://williamhill-lang-gr.custhelp.com/app/answers/detail/a_id/6723" rel="noopener noreferrer" target="_blank">Πολιτική Προστασίας Προσωπικών Δεδομένων</a> μας για περισσότερες πληροφορίες',
          formHeader: 'Κλείστε τον λογαριασμό σας',
          closureReasonPlaceholder: 'Διαλέξτε τον λόγο σας',
          passwordPlaceholder: 'Εισάγετε κωδικό πρόσβασης',
          submitButton: 'Κλείσιμο του λογαριασμού μου',
          reasons: {
            CLOSURE_REASON_OFFERS: 'Δεν είμαι ικανοποιημένος με τις προσφορές σας',
            CLOSURE_REASON_PRODUCTS: 'Δεν είμαι ικανοποιημένος με τα προϊόντα σας',
            CLOSURE_REASON_SERVICE: 'Δεν είμαι ικανοποιημένος με τις υπηρεσίες σας',
            CLOSURE_REASON_TIME: 'Δεν έχω διαθέσιμο χρόνο πλέον για να χρησιμοποιώ τον λογαριασμό μου',
            CLOSURE_REASON_CHANGES: 'Δεν μου αρέσουν οι αλλαγές που κάνατε πρόσφατα',
            CLOSURE_REASON_PROVIDER: 'Χρησιμοποιώ τώρα έναν άλλον πάροχο',
            CLOSURE_REASON_SECRET: 'Προτιμώ να μην αναφέρω'
          }
        },

        accountClosed: {
          title: 'Ο λογαριασμός σας έχει κλείσει',
          text: 'Για να κάνετε ανάληψη<br>' + '<a href="https://williamhill-lang-gr.custhelp.com/app/ask" rel="noopener noreferrer" target="_blank">Επικοινωνήστε με την εξυπηρέτηση πελατών</a><br><br>' + 'Μπορείτε να ανοίξετε ξανά το λογαριασμό σας οποιαδήποτε στιγμή, πηγαίνοντας στη σελίδα Επαναφοράς Λογαριασμού.',
          helpSectionMainText: 'Εάν θέλετε να κάνετε ένα διάλειμμα ή να κλείσετε τον λογαριασμό σας για λόγους ασφαλέστερου τζόγου, σκεφτείτε το χρονικό όριο (έως 6 εβδομάδες) ή τον αυτοαποκλεισμό (έως πέντε χρόνια).<br><br>' + 'Περισσότερες λεπτομέρειες μπορείτε να βρείτε στη σελίδα βοήθειας Υπεύθυνου τζόγου.'
        },

        gamblingHelpSection: {
          bottomSectionTitle: 'Θέλετε ανεξάρτητες συμβουλές;',
          bottomSectionText: 'Εάν θέλετε βοήθεια και συμβουλές σχετικά με τον τρόπο διαχείρισης των επιπέδων τζόγου σας, οι ακόλουθοι σύνδεσμοι μπορεί να σας βοηθήσουν.',
          mainButtonText: 'Μάθετε περισσότερα',
          bottomSectionFirstButton: 'GamCare',
          bottomSectionSecondButton: 'BeGambleAware',
          bottomSectionThirdButton: 'Gambling therapy',
          gamstopHeader: 'GAMSTOP - Λειτουργεί από την The National Online Self-Exclusion Scheme Ltd',
          gamstopContent: 'Σας συνιστούμε ιδιαίτερα να απεγκαταστήσετε τυχόν εφαρμογές στοιχήματος για κινητά από την William Hill και άλλες εταιρείες στοιχηματισμού και να ζητήσετε αυτο-αποκλεισμό από κάθε εταιρεία στοιχημάτων με άδεια στο Ηνωμένο Βασίλειο στην οποία έχετε λογαριασμό, μπορείτε να το κάνετε αυτό μέσω του Gamstop.'
        },

        selfExclusionSelection: {
          viewHeader: {
            title: 'Ορίστε Αυτοαποκλεισμό'
          }
        },

        selfExclusion: {
          viewHeader: {
            title: 'Ορίστε Αυτοαποκλεισμό',
            content: 'Μπορούμε να σας αποκλείσουμε από τις υπηρεσίες μας, εμποδίζοντας την πρόσβαση στα προϊόντα μας για τουλάχιστον 6 μήνες και έως πέντε χρόνια.<br>' + '<a href="https://williamhill-lang-gr.custhelp.com/app/answers/detail/a_id/5939" rel="noopener noreferrer" target="_blank">Πώς λειτουργεί αυτό?</a><br/><br/>' + '<p>Αυτή η ενέργεια δεν μπορεί να αντιστραφεί σε καμία περίπτωση έως ότου λήξει η επιλεγμένη περίοδος Αυτο-αποκλεισμού.</p>'
          },
          upperSectionLabel: 'Σίγουρα επιθυμείτε τον αυτο-αποκλεισμό σας;',
          termsMessage: 'Ναι, επιθυμώ να αποκλειστώ και έχω διαβάσει τους {{termsMessageLink}}',
          termsMessageLink: 'όρους και προϋποθέσεις', // please notice this is a part of the previous key
          formLabel: 'Πόσο χρόνο χρειάζεστε;',
          upperButton: 'Ναι, επιθυμώ τον αυτο-αποκλεισμό μου',
          period: {
            months: '{{amount}} μήνες',
            year: '1 χρόνο',
            years: '{{amount}} χρόνια',
            valueNotSet: 'Χωρίς περίοδο αυτο-αποκλεισμού',
            indefinite: "Επ' αόριστον (ελάχ. 1 έτος)"
          },
          exclusionPeriodPlaceholder: 'Επιλέξτε περίοδο αυτο-αποκλεισμού',
          passwordPlaceholder: 'Πληκτρολογήστε τον κωδικό πρόσβασης',
          submitButton: 'Αίτημα αυτο-αποκλεισμού'
        },

        termsAndConditions: {
          text: 'Αυτό το έγγραφο επιβεβαιώνει την εθελοντική συμφωνία που έχει επιτευχθεί μεταξύ του πελάτη και της WHG (International) Limited, σχετικά με τον αποκλεισμό του πελάτη από τις λειτουργίες στοιχήματος μέσω Διαδικτύου και Τηλεφώνου.<br><br><br>' + 'Ο πελάτης ζητά να κλείσει ο λογαριασμός του και να του απαγορευτεί η δραστηριότητα στοιχήματος και τυχερών παιχνιδιών μέσω τηλεφωνικών και διαδικτυακών στοιχημάτων ή τυχερών παιχνιδιών της WHG (International) Limited για την επιλεγμένη χρονική περίοδο από την ημερομηνία παραλαβής της επιβεβαίωσης του αιτήματος του πελάτη από την WHG (International) Limited και να μην του επιτραπεί να τροποποιήσει, να ανακαλέσει, να αποσύρει ή να άρει τον αυτο-αποκλεισμό του πριν από τη λήξη της παρούσας συμφωνίας.<br><br><br>' + 'Σημείωση: Ο αποκλεισμός από τις λειτουργίες διαδικτύου γίνεται με αναφορά στον αριθμό λογαριασμού και τη διεύθυνση ηλεκτρονικού ταχυδρομείου και ο αποκλεισμός από τις τηλεφωνικές λειτουργίες γίνεται με αναφορά στον αριθμό λογαριασμού. Θα λάβουμε επίσης εύλογα μέτρα για να αποκλείσουμε τη χρήση των αριθμών πιστωτικών και χρεωστικών καρτών που συνδέονται με τους λογαριασμούς του πελάτη. Συνιστούμε ιδιαίτερα στους πελάτες να διαγράψουν/απεγκαταστήσουν όλες τις εφαρμογές ή τις λήψεις που συνδέονται στην William Hill από τις συσκευές τους.<br><br><br>' + 'Στο τέλος της περιόδου εξαίρεσης ή οποιαδήποτε στιγμή μετά, ο πελάτης μπορεί να επανεξετάσει αυτήν την εξαίρεση με τον Υπεύθυνο Εξυπηρέτησης Πελατών και είτε να την ανανεώσει για μια άλλη συγκεκριμένη περίοδο είτε να επιλέξει να συνεχίσει τον στοιχηματισμό. Εάν ζητήσει να μην παραταθεί ο αποκλεισμός, θα υπόκειται σε περαιτέρω περίοδο αποκλεισμού μιας ημέρας πριν του δοθεί πρόσβαση και του επιτραπεί η χρήση του λογαριασμού του.',
          button: 'Έχω διαβάσει τους Όρους και Προϋποθέσεις'
        },

        selfExcluded: {
          title: 'Ο λογαριασμός σας είναι πλέον αυτο-αποκλεισμένος',
          subtitle: {
            months: 'Δεν θα έχετε πρόσβαση στον λογαριασμό σας για {{amount}} μήνες.',
            year: ' Δεν θα έχετε πρόσβαση στον λογαριασμό σας για {{amount}} έτος.',
            years: 'Δεν θα έχετε πρόσβαση στον λογαριασμό σας για {{amount}} χρόνια.',
            indefinite: "Ο λογαριασμός σας αυτο-αποκλείστηκε επ' αόριστον, και δεν θα έχετε πρόσβαση σε αυτόν για τουλάχιστον 1 έτος."
          },
          helpSectionMainText: 'Για να κάνετε ένα διάλειμμα σωστά, πρέπει επίσης να καταργήσετε τυχόν εφαρμογές στοιχημάτων από το τηλέφωνό σας. Τυχόν υπόλοιπο στον λογαριασμό σας θα σας επιστραφεί αυτόματα. Περισσότερες λεπτομέρειες μπορείτε να βρείτε στη σελίδα βοήθειας Ασφαλέστερου Στοιχηματισμού.'
        }
      },

      valueNotSet: 'Δεν έχει οριστεί',
      incorrectPasswordErrorMessage: 'Ο κωδικός πρόσβασης δεν ταιριάζει',
      genericError: 'Δυστυχώς δεν ήταν δυνατή η ολοκλήρωση του αιτήματός σας. Δοκιμάστε ξανά ή επικοινωνήστε με την Εξυπηρέτηση Πελατών για βοήθεια.'
    },

    header: {
      error: {
        message: 'Δεν ήταν δυνατή η λήψη των δεδομένων σας',
        retry: 'Νέα προσπάθεια'
      },
      title: {
        accountNetDeposit: 'Πληροφορίες Καθαρής Κατάθεσης',
        landing: 'Ο Λογαριασμός Μου',
        myAccount: 'Ο Λογαριασμός Μου',
        myBets: 'Τα Στοιχήματά Μου',
        personalDetails: 'Προσωπικά Στοιχεία',
        siteSettings: 'Ρυθμίσεις Ιστότοπου',
        accountHistory: 'Ιστορικό Λογαριασμού',
        loginSecurity: 'Σύνδεση & Ασφάλεια',
        summaryExport: 'Εξαγωγή σύνοψης',
        deposit: 'Κατάθεση',
        saferGambling: 'Ασφαλέστερος Τζόγος',
        depositLimitsPage: 'Όρια Καταθέσεων',
        gamingTimeReminderPage: 'Υπενθύμιση χρόνου παιχνιδιού',
        accountClosure: 'Κλείσιμο λογαριασμού',
        accountClosed: 'Κλείσιμο λογαριασμού',
        timeOutResult: 'Διάλειμμα',
        timeOut: 'Διάλειμμα',
        termsAndConditions: 'Αυτοαποκλεισμός',
        selfExclusionSelectionPage: 'Αυτοαποκλεισμός',
        selfExclusionPage: 'Αυτοαποκλεισμός',
        selfExcluded: 'Αυτοαποκλεισμός'
      }
    },
    balanceAndBonus: {
      cashBalance: 'Χρηματικό Υπόλοιπο',
      additionalBalance: { sportsbook: 'Δωρεάν Στοιχήματα', gaming: 'Μπόνους Παιχνιδιού' },
      balanceInfoLink: 'Πληροφορίες Υπολοίπου'
    },
    transactions: {
      reference: 'Αρ. Αναφοράς',
      aamsId: 'ID AAMS:',
      EW: 'KK',
      eachWay: 'KK 1-{{places}} Τοποθετήσεις, {{price}} Τιμή',
      stake: 'Στοίχημα',
      refund: 'Επιστροφή',
      return: 'Επιστροφή',
      bonusStake: 'Στοίχημα μπόνους',
      stakeTotal: 'Συνολικό ποντάρισμα',
      tab: {
        summary: 'Περίληψη',
        history: 'Συναλλαγές'
      },
      myBets: {
        open: 'Ανοικτό',
        settled: 'Εκκαθαρισμένο'
      },
      numberOfLines: 'x {{value}} Στοιχήματα',
      price: {
        '@ SP': '@ ΑΤ (Αρχική Τιμή)',
        '@ Guaranteed Price': '@ Εγγυημένη τιμή ({{price}})'
      },
      accountNetDeposit: {
        buttonLabel: 'Δείτε τις Δικές σας',
        buttonTitle: 'Πληροφορίες Καθαρής Κατάθεσης'
      },
      lotteryBet: {
        draw: 'Ισοπαλία:',
        result: 'Αποτέλεσμα:'
      },
      totePoolBetting: 'Στοίχημα μπιλιάρδου',
      bettingTerminal: 'Τερματικό Στοιχηματισμού',
      type: {
        BET_ACCUMULATOR_10: 'Συσσωρευτής (10)',
        BET_ACCUMULATOR_11: 'Συσσωρευτής (11)',
        BET_ACCUMULATOR_12: 'Συσσωρευτής (12)',
        BET_ACCUMULATOR_13: 'Συσσωρευτής (13)',
        BET_ACCUMULATOR_14: 'Συσσωρευτής (14)',
        BET_ACCUMULATOR_15: 'Συσσωρευτής (15)',
        BET_ACCUMULATOR_16: 'Συσσωρευτής (16)',
        BET_ACCUMULATOR_17: 'Συσσωρευτής (17)',
        BET_ACCUMULATOR_18: 'Συσσωρευτής (18)',
        BET_ACCUMULATOR_19: 'Συσσωρευτής (19)',
        BET_ACCUMULATOR_20: 'Συσσωρευτής (20)',
        BET_ACCUMULATOR_21: 'Συσσωρευτής (21)',
        BET_ACCUMULATOR_22: 'Συσσωρευτής (22)',
        BET_ACCUMULATOR_23: 'Συσσωρευτής (23)',
        BET_ACCUMULATOR_24: 'Συσσωρευτής (24)',
        BET_ACCUMULATOR_25: 'Συσσωρευτής (25)',
        BET_ACCUMULATOR_4: 'Τετραπλό',
        BET_ACCUMULATOR_5: 'Πενταπλό',
        BET_ACCUMULATOR_6: 'Εξαπλό',
        BET_ACCUMULATOR_7: 'Επταπλό',
        BET_ACCUMULATOR_8: 'Οκταπλό',
        BET_ACCUMULATOR_9: 'Εννιαπλό',
        BET_CANADIAN: 'Καναδέζικο',
        BET_DDB: 'Tote - Καθημερινό Διπλό',
        BET_DOUBLE: 'Διπλό',
        BET_DOUBLES: 'Διπλά',
        BET_EIGHTFOLDS: 'Οκταπλά',
        BET_EXA: 'Tote - Εξάκτα',
        BET_FIVEFOLDS: 'Πενταπλά',
        BET_FLG: 'Σημαία',
        BET_FOURFOLDS: 'Τετραπλά',
        BET_GOLIATH: 'Γολιάθ',
        BET_HEINZ: 'Χάινς',
        BET_LUCKY_15: 'Τυχερό 15',
        BET_LUCKY_31: 'Τυχερό 31',
        BET_LUCKY_63: 'Τυχερό 63',
        BET_MAN: 'Γραπτό στοίχημα',
        BET_NINEFOLDS: 'Εννιαπλά',
        BET_PATENT: 'Πατέντα',
        BET_PK3: 'Tote - Επιλογή 3',
        BET_PK4: 'Tote - Επιλογή 4',
        BET_PK6: 'Tote - Επιλογή 6',
        BET_PK9: 'Tote - Επιλογή 9',
        BET_PLC: 'Tote - Θέση',
        BET_QIN: 'Tote - Δίδυμο',
        BET_ROB: 'Ράουντ Ρόμπιν',
        BET_SEVENFOLDS: 'Επταπλά',
        BET_SHW: 'Tote - Σόου',
        BET_SINGLE: 'Μονό',
        BET_SIXFOLDS: 'Εξαπλά',
        BET_SPR: 'Tote - Σουπερφέκτα',
        BET_SUPER_HEINZ: 'Σούπερ Χάινς',
        BET_TENFOLDS: 'Δεκαπλά',
        BET_TREBLE: 'Τρεμπλ',
        BET_TREBLES: 'Τρεμπλ',
        BET_TRI: 'Tote - Τριφέκτα',
        BET_TRIXIE: 'Τρίξι',
        BET_UEXA: 'Tote - Εξάκτα',
        BET_UJKP: 'Tote - Τζακπότ',
        BET_UKN: 'Στοίχημα',
        BET_UPLC: 'Tote - Θέση',
        BET_UPLP: 'Tote - Πλέις-ποτ',
        BET_UQDP: 'Tote - Κουάντ-ποτ',
        BET_USC6: 'Tote - Σκουπ 6',
        BET_USC7: 'Tote - Σούπερ7',
        BET_USW: 'Tote - Σουίνγκερ',
        BET_UTD: 'Tote - Διπλό',
        BET_UTRI: 'Tote - Τριφέκτα',
        BET_UTT: 'Tote - Τρεμπλ',
        BET_UWIN: 'Tote - Νίκη',
        BET_WIN: 'Tote - Νίκη',
        BET_YANKEE: 'Γιάνκι',
        BONUS: 'Προσαρμογή Υπολοίπου',
        DEPOSIT: 'Κατάθεση',
        PRIORITY_CARD_CASH: 'Μετρητά',
        PRIORITY_CARD_CASHBACK: 'Αγορά με επιστροφή μετρητών',
        PRIORITY_CARD_DEPOSIT: 'Κατάθεση',
        PRIORITY_CARD_NON_CASH: 'Εκτός Μετρητών',
        PRIORITY_CARD_OTHER: 'Άλλο',
        PRIORITY_CARD_PURCHASE: 'Αγορά',
        PRIORITY_CARD_QUASI_CASH: 'Quasi-cash',
        PRIORITY_CARD_REFUND: 'Επιστροφή Χρημάτων',
        PRIORITY_CARD_TRANSACTION: 'Πληρωμή',
        REVERSAL: 'Αντιστροφή',
        MANUAL_ADJUSTMENT: 'Χειροκίνητη Προσαρμογή',
        WITHDRAWAL: 'Ανάληψη',
        TRANSFER: 'Μεταφορά',
        CASINO: 'Καζίνο',
        VEGAS: 'Βέγκας',
        SLOTS: 'Κουλοχέρηδες',
        GAMES: 'Παιχνίδια',
        POKER: 'Πόκερ',
        BINGO: 'Μπίνγκο',
        LIVE_CASINO: 'Live Καζίνο'
      },
      manualAdjustmentType: {
        AFFP: 'Πληρωμές Συνεργατών',
        AFFR: 'Rakeback Συνεργατών',
        BCNV: 'Μετατροπή Υπολοίπου',
        BETC: 'Διόρθωση Στοιχήματος',
        BNJW: 'Νίκες Τζακπότ',
        BNKC: 'Τραπεζικές Χρεώσεις',
        BONS: 'Μη Αυτόματο Μπόνουςs',
        BPCS: 'Πληρωμή Μπόνους (cs)',
        BTCS: 'Μεταφορά Υπολοίπου (cs)',
        CADJ: 'Προσαρμογή Προμήθειας',
        CSH: 'Προσαρμογές Μετρητών',
        CWIN: 'Μοίρασμα Κερδών',
        GWCS: 'Κίνηση Καλής Θέλησης (cs)',
        GWIL: 'Κίνηση Καλής Θέλησης',
        HEDG: 'Αντιστάθμιση',
        INAC: 'Χρέωση Αδράνειας',
        ISCS: 'Λανθασμένη Εκκαθάριση (cs)',
        LFND: 'Χαμένα / Κρατημένα Κεφάλαια',
        MCM: 'Χειροκίνητη Μετακίνηση Μετρητών',
        ONCR: 'Σε-Εξέλιξη',
        PGCW: 'Προ GC Αφαίρεση',
        RCHQ: 'Επιστροφή Ποσού',
        SCHQ: 'Διακοπή Απόσυρσης Ποσού',
        TFCS: 'Κρατημένα Κεφάλαια (cs)',
        WOFF: 'Αφαίρεση'
      },
      result: {
        WIN: 'Νίκη',
        LOST: 'Ζημία',
        VOIDED: 'Ακυρωμένο',
        CASHED_IN: 'Εξαργυρωμένο',
        STAKE: 'Στοίχημα',
        CANCELED: 'Ακυρώθηκε',
        PLACED: 'Τοποθετήθηκε'
      },
      paymentMethod: {
        APPLEPAY: 'Apple Pay',
        BANKTRANSFER: 'Τραπεζική Μεταφορά',
        CARD: 'Πιστωτική/Χρεωστική Κάρτα',
        CHEQUE: 'Επιταγή',
        CLICK2PAY: 'Click2Pay',
        CLICKANDBUY: 'Click And Buy',
        DIRECTBANKTRANSFER: 'Απευθείας Τραπεζική Μεταφορά',
        ECOPAYZ: 'EcoPayz',
        ENTROPAY: 'Entropay',
        ENVOY: 'Envoy',
        EPAYVOUCHER: 'ePay Voucher',
        NETELLER: 'Neteller',
        OTHER: 'Άλλο',
        PAYPAL: 'PayPal',
        PAYSAFECARD: 'Κάρτα Paysafe',
        PINGIT: 'Pingit',
        PLUS: 'Κάρτα Plus',
        QUICKCASH: 'CashDirect',
        SKRILL: 'Skrill',
        UKASH: 'Ukash International',
        WESTERNUNION: 'Western Union',
        MUCHBETTER: 'MuchBetter'
      },
      sort: {
        ANYTIME_SCORECAST: 'Anytime Scorecast',
        ANYTIME_WINCAST: 'Γουινκάστ Anytime',
        ASIAN_HANDICAP: 'Ασιατικό Χάντικαπ',
        BYO: 'Build #YourOdds',
        COMBINATION_FIRST_FOUR: 'Συνδυασμός Πρώτα Τέσσερα',
        COMBINATION_FORECAST: 'Συνδυασμός Φορκάστ',
        COMBINATION_QUINELLA: 'Συνδυασμός Δίδυμο',
        COMBINATION_TRICAST: 'Συνδυασμός Τρικάστ',
        CONTINUOUS_WIN: 'Συνεχής Νίκη',
        FIRST_FOUR: 'Πρώτα Τέσσερα',
        FIRST_HALF_ASIAN_HANDICAP: 'Ασιατικό Χάντικαπ Πρώτο Ημίχρονο',
        FIRST_HALF_OUTRIGHT: 'Καθαρή Νίκη Πρώτο Ημίχρονο',
        FIRST_HALF_WESTERN_HANDICAP: 'Δυτικό Χάντικαπ Πρώτο Ημίχρονο',
        FIRST_WINCAST: 'Θα Τερματίσει 1ο',
        FORECAST: 'Φορκάστ',
        HIGHER_LOWER: 'Υψηλότερα/Χαμηλότερα',
        HIGHER_LOWER_SPLIT_OFFER: 'Υψηλότερα/Χαμηλότερα (με προσφορά σπλιτ)',
        INSURED_SCORECAST: 'Ασφαλισμένο Σκορκάστ',
        INSURED_WINCAST: 'Ασφαλισμένο Γουινκάστ',
        LAST_SCORECAST: 'Τελευταίο Σκορκάστ',
        LAST_WINCAST: 'Τελευταίο Γουινκάστ',
        MATCH_HANDICAP: 'Χάντικαπ Αγώνα',
        OVER_UNDER: 'Over/Under',
        PERMED_FORECAST: 'Φορκάστ Permed',
        PERMED_TRICAST: 'Τρικάστ Permed',
        POINTS_MARKET: 'Αγορά Πόντων',
        QUINELLA: 'Δίδυμο',
        REVERSE_FORECAST: 'Ανάστροφο Φορκάστ',
        SCORECAST: 'Σκορκάστ',
        SECOND_HALF_ASIAN_HANDICAP: 'Ασιατικό Χάντικαπ Δευτέρου Ημιχρόνου',
        SECOND_HALF_OUTRIGHT: 'Ξεκάθαρη Νίκη Δευτέρου Ημιχρόνου',
        SECOND_HALF_WESTERN_HANDICAP: 'Δυτικό Χάντικαπ Δευτέρου Ημιχρόνου',
        SIMPLE: 'Απλό',
        STANDOUT_FIRST_FOUR: 'Standout Πρώτα Τέσσερα',
        STANDOUT_FORECAST: 'Standout Φορκάστ',
        STANDOUT_QUINELLA: 'Standout Δίδυμο',
        STANDOUT_TRICAST: 'Standout Τρικάστ',
        STRAIGHT_FORECAST: 'Straight Φορκάστ',
        TRICAST: 'Τρικάστ',
        TRICAST_OPTIONS: 'Επιλογές Τρικάστ',
        WESTERN_HANDICAP: 'Δυτικό (straight) Χάντικαπ',
        XTH_SCORER_SCORECAST: 'Scorecast Σειρά Σκόρερ',
        XTH_SCORER_WINCAST: 'Γουινκάστ Σειρά Σκόρερ'
      },
      boostedBet: 'Προωθημένο Στοίχημα',
      loadMore: 'Φόρτωση περισσότερων',
      noTransactions: 'Χωρίς συναλλαγές',
      resetFilters: {
        filtersApplied: 'Εφαρμοσμένα φίλτρα',
        removeFilters: 'Αφαίρεση Όλων'
      },
      summary: {
        correctAsOfMidnight: 'Σωστό από τα μεσάνυχτα',
        lastRefresh: '{{day}} {{month}} {{year}}',
        profitLoss: 'Κέρδος και ζημία',
        sports: 'Ποντάρισμα σε Αθλήματα',
        gaming: 'Παιχνίδια',
        profitLossBreakdown: 'Κατανομή Κερδών και Ζημιών',
        winsLosses: 'Νίκη - Ήττα',
        netDeposit: 'Καθαρές Καταθέσεις',
        lifetimeNetDeposit: 'Μέσος Όρος Καθαρών Καταθέσεων',
        totalDepositsWithdrawals: 'Σύνολο Αναλήψεων - Σύνολο Καταθέσεων',
        netDepositAvailableFrom: 'Πληροφορίες διαθέσιμες μόνο από 6/12/2008',
        saferGamblingNote: {
          title: 'Στοιχηματίζεται με ασφάλεια?',
          description: 'Βεβαιωθείτε ότι συνεχίζετε να διασκεδάζετε με τα τυχερά παιχνίδια και δεν ξοδεύετε παραπάνω από όσα αντέχετε οικονομικά. Εάν χρειάζεστε κάποια βοήθεια ρίξτε μια ματιά στα {{link}}.',
          link: 'εργαλεία Ασφαλούς Στοιχηματισμού'
        }
      }
    },
    filters: {
      dropdown: {
        transactionsSummary: {
          date: 'Μήνας μέχρι ημερομηνία',
          filters: 'Φίλτρα'
        },
        transactionsHistory: {
          date: 'Τελευταίες 7 ημέρες',
          filters: 'Φίλτρα'
        }
      },
      customDateRange: {
        toLabel: 'έως',
        labels: {
          from: 'από',
          to: 'έως'
        },
        error: 'Παρακαλούμε επιλέξτε ένα έγκυρο εύρος ημερομηνιών ή εναλλακτικά διαλέξτε μια διαφορετική επιλογή ημερομηνίας',
        historyLimitation: {
          caption: 'Λάβετε υπόψη ότι συναλλαγές παλαιότερες του 1 έτους ενδέχεται να μην είναι \
διαθέσιμες. Εάν θέλετε να δείτε αυτές τις συναλλαγές, επικοινωνήστε με ',
          link: 'τις υπηρεσίες εξυπηρέτησης πελατών'
        }
      },
      predefinedDateRange: {
        sectionName: 'Προκαθορισμένο εύρος ημερομηνιών',
        allDates: 'Όλες οι ημερομηνίες',
        last7: 'Τελευταίες 7 ημέρες',
        last14: 'Τελευταίες 14 ημέρες',
        last30: 'Τελευταίες 30 ημέρες',
        custom: 'Προσαρμοσμένο Εύρος'
      },
      transactionsSummaryDateRange: {
        sectionName: 'Επιλογή εύρους ημερομηνιών',
        monthToDate: 'Μήνας μέχρι ημερομηνία',
        last7days: 'Τελευταίες 7 ημέρες',
        last12months: 'Τελευταίοι 12 μήνες'
      },
      view: {
        sectionName: 'Προβολή',
        all: 'Όλα',
        onlyPayments: 'Μόνο Πληρωμές',
        excludePayments: 'Εκτός Πληρωμών',
        onlyWins: 'Μόνο Νίκες',
        onlyLosses: 'Μόνο Ζημίες'
      },
      showHideBetTypes: {
        sectionName: 'Εμφάνιση / Απόκρυψη Στοιχημάτων',
        singles: 'Μονά',
        multiples: 'Πολλαπλά'
      },
      tabs: {
        all: 'Όλα',
        sports: 'Αθλήματα',
        gaming: 'Παιχνίδια'
      },
      applyFilters: 'Εφαρμογή'
    },
    footer: {
      button: {
        logout: {
          text: 'Αποσύνδεση'
        }
      },
      link: {
        feedback: 'Σχόλια',
        help: 'Βοήθεια'
      }
    },
    oddsFormat: {
      title: 'Μορφή Αποδόσεων',
      decimal: 'Δεκαδικό',
      fractional: 'Κλάσμα'
    },

    personalDetails: {
      tabs: {
        contact: 'Επικοινωνία',
        marketing: 'Μάρκετινγκ'
      }
    },
    personalDetailsContact: {
      securityMessage: {
        title: 'Στη William Hill παίρνουμε την ασφάλεια και το απόρρητο του λογαριασμού σας σοβαρά.',
        text: 'Κρατάμε τα στοιχεία επικοινωνίας σας σε μια ασφαλή τοποθεσία, συμπεριλαμβανομένου του ονόματος, της ταχυδρομικής διεύθυνσης, του αριθμού τηλεφώνου σας \
& email. Για να ενημερώσετε τα στοιχεία σας, παρακαλούμε συμπληρώστε τα παρακάτω πεδία και πατήστε ’Ενημέρωση στοιχείων μου’. \
τα ενημερωμένα στοιχεία θα αποθηκευτούν στα συστήματά μας αλλά δεν θα εμφανιστούν στη σελίδα.'
      },
      statusMessage: {
        success: 'Τα Προσωπικά Στοιχεία ενημερώθηκαν με Επιτυχία',
        failure: 'Κάτι πήγε στραβά'
      },
      fields: {
        email: {
          label: 'Email'
        },
        addressLine1: {
          label: 'Γραμμή Διεύθυνσης 1'
        },
        addressLine2: {
          label: 'Γραμμή Διεύθυνσης 2'
        },
        addressCity: {
          label: 'Πόλη'
        },
        addressCounty: {
          label: 'Περιφέρεια/πολιτεία (προαιρετικό)'
        },
        addressPostcode: {
          label: 'ΤΚ'
        },
        country: {
          label: 'Χώρα',
          defaultValue: 'Παρακαλούμε επιλέξτε από τη λίστα.'
        },
        mobile: {
          label: 'Αριθμός Κινητού'
        }
      },
      buttons: {
        submit: 'Ενημέρωση στοιχείων μου'
      },
      validationRules: {
        email: {
          required: 'Η διεύθυνση email δεν μπορεί να είναι κενή',
          maxLength: 'Πολύ μεγάλο. 60 χαρακτήρες το πολύ',
          email: 'Πρέπει να είναι μια έγκυρη διεύθυνση email'
        },
        street1: {
          required: 'Η διεύθυνση είναι υποχρεωτικό πεδίο',
          maxLength: 'Πολύ μεγάλο. 160 χαρακτήρες το πολύ',
          pattern: 'Μη έγκυρος χαρακτήρας'
        },
        street2: {
          required: 'Η διεύθυνση είναι υποχρεωτικό πεδίο',
          maxLength: 'Πολύ μεγάλο. 160 χαρακτήρες το πολύ',
          pattern: 'Μη έγκυρος χαρακτήρας'
        },
        city: {
          required: 'Η πόλη είναι υποχρεωτικό πεδίο',
          pattern: 'Μη έγκυρος χαρακτήρας',
          maxLength: 'Πολύ μεγάλο. 60 χαρακτήρες το πολύ'
        },
        county: {
          pattern: 'Μη έγκυρος χαρακτήρας',
          maxLength: 'Πολύ μεγάλο. 60 χαρακτήρες το πολύ'
        },
        postcode: {
          required: 'Ο ΤΚ δεν μπορεί να είναι κενός',
          pattern: 'Μη έγκυρος χαρακτήρας',
          maxLength: 'Πολύ μεγάλο. 12 χαρακτήρες το πολύ'
        },
        mobile: {
          required: 'Ο αριθμός τηλεφώνου δεν μπορεί να είναι κενός',
          pattern: 'Μη έγκυρος χαρακτήρας. Μόνο αριθμοί είναι αποδεκτοί',
          minLength: 'Πολύ μικρό. Τουλάχιστον 6 χαρακτήρες',
          maxLength: 'Πολύ μεγάλο. 20 χαρακτήρες το πολύ'
        }
      }
    },
    personalDetailsTimezone: {
      statusMessage: {
        success: 'Η ζώνη ώρας ενημερώθηκε με επιτυχία',
        failure: 'Κάτι πήγε στραβά'
      },
      buttons: {
        updateTimezone: 'Ενημέρωση ζώνης ώρας'
      },
      fields: {
        timezones: {
          label: 'ζώνης ώρας',
          values: {
            TIMEZONE_AFRICA_ADDIS_ABABA: 'Αφρική/Αντίς_Αμπέμπα ',
            TIMEZONE_AFRICA_JOHANNESBURG: 'Αφρική/Γιοχάνεσμπουργκ',
            TIMEZONE_AMERICA_ANCHORAGE: 'Αμερική/Άνκορατζ',
            TIMEZONE_AMERICA_ARGENTINA_BUENOS_AIRES: 'Αμερική/Αργεντινή/Μπουένος_Άιρες',
            TIMEZONE_AMERICA_CHICAGO: 'Αμερική/Σικάγο',
            TIMEZONE_AMERICA_DENVER: 'Αμερική/Ντένβερ',
            TIMEZONE_AMERICA_LOS_ANGELES: 'Αμερική/Λος_Άντζελες',
            TIMEZONE_AMERICA_NEW_YORK: 'Αμερική/Νέα_Υόρκη',
            TIMEZONE_AMERICA_SAO_PAULO: 'Αμερική/Σάο_Πάολο',
            TIMEZONE_AMERICA_TORONTO: 'Αμερική/Τορόντο',
            TIMEZONE_AMERICA_VANCOUVER: 'Αμερική/Βανκούβερ',
            TIMEZONE_ASIA_BANGKOK: 'Ασία/Μπανγκόκ',
            TIMEZONE_ASIA_DHAKA: 'Ασία/Ντάκα',
            TIMEZONE_ASIA_DUBAI: 'Ασία/Ντουμπάι',
            TIMEZONE_ASIA_HONG_KONG: 'Ασία/Χονγκ_Κονγκ',
            TIMEZONE_ASIA_JERUSALEM: 'Ασία/Ιερουσαλήμ',
            TIMEZONE_ASIA_KARACHI: 'Ασία/Καράτσι',
            TIMEZONE_ASIA_KOLKATA: 'Ασία/Καλκούτα',
            TIMEZONE_ASIA_RANGOON: 'Ασία/Ρανγκούν',
            TIMEZONE_ASIA_SINGAPORE: 'Ασία/Σιγκαπούρη',
            TIMEZONE_ASIA_TOKYO: 'Ασία/Τόκιο',
            TIMEZONE_ATLANTIC_AZORES: 'Ατλαντικός/Αζόρες',
            TIMEZONE_ATLANTIC_BERMUDA: 'Ατλαντικός/Βερμούδες',
            TIMEZONE_AUSTRALIA_ADELAIDE: 'Αυστραλία/Αδελαΐδα',
            TIMEZONE_AUSTRALIA_PERTH: 'Αυστραλία/Περθ',
            TIMEZONE_AUSTRALIA_SYDNEY: 'Αυστραλία/Σίδνεϊ',
            TIMEZONE_EUROPE_ATHENS: 'Ευρώπη/Αθήνα',
            TIMEZONE_EUROPE_BERLIN: 'Ευρώπη/Βερολίνο',
            TIMEZONE_EUROPE_DUBLIN: 'Ευρώπη/Δουβλίνο',
            TIMEZONE_EUROPE_GIBRALTAR: 'Ευρώπη/Γιβραλτάρ',
            TIMEZONE_EUROPE_KIEV: 'Ευρώπη/Κίεβο',
            TIMEZONE_EUROPE_LONDON: 'Ευρώπη/Λονδίνο',
            TIMEZONE_EUROPE_MADRID: 'Ευρώπη/Μαδρίτη',
            TIMEZONE_EUROPE_MOSCOW: 'Ευρώπη/Μόσχα',
            TIMEZONE_EUROPE_PARIS: 'Ευρώπη/Παρίσι',
            TIMEZONE_EUROPE_ROME: 'Ευρώπη/Ρώμη',
            TIMEZONE_EUROPE_SOFIA: 'Ευρώπη/Σόφια',
            TIMEZONE_EUROPE_VIENNA: 'Ευρώπη/Βιέννη',
            TIMEZONE_EUROPE_WARSAW: 'Ευρώπη/Βαρσοβία',
            TIMEZONE_INDIAN_CHRISTMAS: 'Ινδικός/Νήσος των Χριστουγέννων',
            TIMEZONE_PACIFIC_AUCKLAND: 'Ειρηνικός/Ώκλαντ',
            TIMEZONE_PACIFIC_GUADALCANAL: 'Ειρηνικός/Γκουανταλκανάλ',
            TIMEZONE_PACIFIC_HONOLULU: 'Ειρηνικός/Χονολουλού',
            TIMEZONE_PACIFIC_MIDWAY: 'Ειρηνικός/Μίντγουεϊ'
          }
        }
      },
      validationRules: {
        required: 'Επιλέξτε ζώνη ώρας'
      }
    },
    personalDetailsMarketing: {
      mainNote: 'Θέλω να λάβω νέα για μπόνους, προσφορές και υπηρεσίες μέσω email, SMS ή τηλεφώνου. \
Μπορείτε να ενημερώσετε/επεξεργαστείτε τις προτιμήσεις σας ανά πάσα στιγμή.',
      contactMethodLabel: {
        telephone: 'Κλήση',
        email: 'Email',
        sms: 'SMS'
      },
      error: {
        save: 'Λυπούμαστε. Τα δεδομένα σας δεν μπορούν να αποθηκευτούν αυτήν τη στιγμή. Παρακαλούμε δοκιμάστε πάλι.'
      },
      disclaimer: {
        text: 'Αποποίηση ευθύνης: ',
        note: 'Παρακαλούμε σημειώστε ότι μπορούν να χρειαστούν έως 48 ώρες για να εφαρμοστούν οι αλλαγές. \
Χρησιμοποιούμε ειδοποιήσεις push ως μέρος των υπηρεσιών μας. Μπορείτε να έχετε έλεγχο των ρυθμίσεων για τις ειδοποιήσεις σας push \
στη συσκευή σας. Εάν χρησιμοποιείτε περισσότερες από μία συσκευές για να έχετε πρόσβαση στην υπηρεσία \
χρειάζεται να προσαρμόσετε τις ρυθμίσεις σας σε κάθε συσκευή.'
      }
    },
    loginSecurity: {
      changePassword: 'Αλλαγή κωδικού πρόσβασης',
      currentPassword: 'Τρέχων Κωδικός Πρόσβασης',
      newPassword: 'Νέος Κωδικός Πρόσβασης',
      savePassword: 'Αποθήκευση Νέου Κωδικού πρόσβασης',
      passwordUpdated: 'Ο κωδικός πρόσβασής σας έχει ενημερωθεί',
      genericErrorMessage: 'Κάτι πήγε στραβά',
      validationRules: {
        currentPassword: {
          required: 'Το πεδίο του τρέχοντος κωδικού πρόσβασης είναι κενό.',
          invalidCredentials: 'Λανθασμένος Κωδικός Πρόσβασης'
        },
        newPassword: {
          required: 'Το πεδίο του νέου κωδικού πρόσβασης είναι κενό.',
          hasDigit: 'Ο νέος κωδικός πρόσβασης δεν περιλαμβάνει κάποιο από τα ακόλουθα: έναν αριθμό, ένα μικρό γράμμα και ένα κεφαλαίο.',
          hasUppercaseLetter: 'Ο νέος κωδικός πρόσβασης δεν περιλαμβάνει κάποιο από τα ακόλουθα: έναν αριθμό, ένα μικρό γράμμα και ένα κεφαλαίο.',
          cannotBeEqualToLastPassword: 'Ο νέος κωδικός πρόσβασης δεν μπορεί να είναι ίδιος με τον τελευταίο κωδικό πρόσβασης.'
        }
      }
    },
    accountNetDeposit: {
      title: 'Καθαρό ποσό κατάθεσης διάρκειας ζωής λογαριασμού',
      description: 'Το καθαρό ποσό κατάθεσης δείχνει το άθροισμα όλων των συναλλαγών για τον λογαριασμό σας (καταθέσεις μείον αναλήψεις).',
      accessNote: 'Παρακαλούμε λάβετε υπόψη ότι μπορούμε να έχουμε πρόσβαση μόνο σε πληροφορίες λογαριασμού από τις 6/12/2008.',
      timePeriod: {
        title: 'Χρονική περίοδος Καθαρής κατάθεσης',
        description: 'Η καθαρή κατάθεση για την επιλεγμένη χρονική περίοδο. Όλες οι χρονικές περιόδοοι ξεκινούν από την προηγούμενη πλήρη ημέρα. Θα στείλουμε αυτές τις πληροφορίες στην καταχωρημένη διεύθυνση email σας εντός 24 ωρών.',
        optionsTitle: 'Επιλογή περιόδου',
        optionLabels: {
          LAST_DAY: 'Προηγούμενη μέρα',
          LAST_WEEK: 'Προηγούμενες 7 ημέρες',
          LAST_MONTH: 'Προηγούμενες 30 ημέρες'
        },
        success: 'Θα στείλουμε αυτές τις πληροφορίες στην καταχωρημένη διεύθυνση email σας εντός 24 ωρών.',
        requestDeposit: 'Στείλτε μου με email την επιλεγμένη Καθαρή κατάθεση'
      },
      lifetimeNetDepositButton: 'Προβολή καθαρής κατάθεσης διάρκειας ζωής λογαριασμού'
    },
    error: {
      network: {
        text: 'Παρουσιάστηκε κάποιο σφάλμα δικτύου.',
        subText: 'Παρακαλούμε δοκιμάστε ξανά σε λίγο.',
        retrySubText: 'Παρακαλούμε ανοίξτε ξανά την ενότητα Ο Λογαριασμός Μου σε λίγο.'
      },
      graphQL: {
        text: 'Ουπς, δεν ήταν δυνατό να γίνει λήψη των δεδομένων που ζητήσατε.',
        subText: 'Παρακαλούμε δοκιμάστε ξανά σε λίγο.',
        retrySubText: 'Παρακαλούμε ανοίξτε ξανά την ενότητα Ο Λογαριασμός Μου σε λίγο.'
      },
      retry: 'Νέα προσπάθεια',
      iconAlt: 'Traffic Cone'
    },
    confirmationModal: {
      confirmationText: 'Ναί',
      cancellationText: 'Οχι'
    }
  },
  countries: {
    COUNTRY_AD: 'Ανδόρα',
    COUNTRY_AE: 'Ηνωμένα Αραβικά Εμιράτα',
    COUNTRY_AF: 'Αφγανιστάν',
    COUNTRY_AG: 'Αντίγκουα και Μπαρμπούντα',
    COUNTRY_AI: 'Ανγκουίλα',
    COUNTRY_AL: 'Αλβανία',
    COUNTRY_AM: 'Αρμενία',
    COUNTRY_AN: 'Ολλανδικές Αντίλλες',
    COUNTRY_AO: 'Αγκόλα',
    COUNTRY_AQ: 'Ανταρκτική',
    COUNTRY_AR: 'Αργεντινή',
    COUNTRY_AS: 'Αργεντινή',
    COUNTRY_AT: 'Αυστρία',
    COUNTRY_AU: 'Αυστραλία',
    COUNTRY_AW: 'Αρούμπα',
    COUNTRY_AX: 'Νήσοι Αλάντ',
    COUNTRY_AZ: 'Αζερμπαϊτζάν',
    COUNTRY_BA: 'Βοσνία-Ερζεγοβίνη',
    COUNTRY_BB: 'Μπαρμπέιντος',
    COUNTRY_BC: 'Βρετανική Κολούμπια',
    COUNTRY_BD: 'Μπανγκλαντές',
    COUNTRY_BE: 'Βέλγιο',
    COUNTRY_BF: 'Μπουρκίνα Φάσο',
    COUNTRY_BG: 'Βουλγαρία',
    COUNTRY_BH: 'Μπαχρέιν',
    COUNTRY_BI: 'Μπουρούντι',
    COUNTRY_BJ: 'Μπενίν',
    COUNTRY_BM: 'Βερμούδα',
    COUNTRY_BN: 'Бруней Даруссалам',
    COUNTRY_BO: 'Βολιβία',
    COUNTRY_BR: 'Βραζιλία',
    COUNTRY_BS: 'Μπαχάμες',
    COUNTRY_BT: 'Μπουτάν',
    COUNTRY_BV: 'Νήσος Μπούβε',
    COUNTRY_BW: 'Μποτσουάνα',
    COUNTRY_BY: 'Λευκορωσία',
    COUNTRY_BZ: 'Μπελίζε',
    COUNTRY_CA: 'Καναδάς',
    COUNTRY_CC: 'Νήσοι Κόκος (Κίλινγκ)',
    COUNTRY_CD: 'Δημοκρατία του Κονγκό',
    COUNTRY_CF: 'Κεντροαφρικανική Δημοκρατία',
    COUNTRY_CG: 'Λαϊκή Δημοκρατία του Κονγκό',
    COUNTRY_CH: 'Ελβετία',
    COUNTRY_CI: 'Ακτή Ελεφαντοστού',
    COUNTRY_CK: 'Νήσοι Κουκ',
    COUNTRY_CL: 'Χιλή',
    COUNTRY_CM: 'Καμερούν',
    COUNTRY_CN: 'Λαϊκή Δημοκρατία της Κίνας',
    COUNTRY_CO: 'Κολομβία',
    COUNTRY_CR: 'Κόστα Ρίκα',
    COUNTRY_CU: 'Κούβα',
    COUNTRY_CV: 'Πράσινο Ακρωτήριο',
    COUNTRY_CX: 'Νησί των Χριστουγέννων',
    COUNTRY_CY: 'Κύπρος',
    COUNTRY_CZ: 'Τσεχική Δημοκρατία',
    COUNTRY_DE: 'Γερμανία',
    COUNTRY_DJ: 'Τζιμπουτί',
    COUNTRY_DK: 'Δανία',
    COUNTRY_DM: 'Δομινίκα',
    COUNTRY_DO: 'Δομινικανή Δημοκρατία',
    COUNTRY_DZ: 'Αλγερία',
    COUNTRY_EC: 'Εκουαδόρ',
    COUNTRY_EE: 'Εσθονία',
    COUNTRY_EG: 'Αίγυπτος',
    COUNTRY_EH: 'Δυτική Σαχάρα',
    COUNTRY_ER: 'Ερυθραία',
    COUNTRY_ES: 'Ισπανία',
    COUNTRY_ET: 'Αιθιοπία',
    COUNTRY_EU: 'Ευρωπαϊκή Ένωση',
    COUNTRY_FI: 'Φινλανδία',
    COUNTRY_FJ: 'Φίτζι',
    COUNTRY_FK: 'Νήσοι Φώκλαντ',
    COUNTRY_FM: 'Μικρονησία',
    COUNTRY_FO: 'Νήσοι Φερόες',
    COUNTRY_FR: 'Γαλλία',
    COUNTRY_FX: 'Μητροπολιτική Γαλλία',
    COUNTRY_GA: 'Γκαμπόν',
    COUNTRY_GD: 'Γρενάδα',
    COUNTRY_GE: 'Γεωργία',
    COUNTRY_GF: 'Γαλλική Γουιάνα',
    COUNTRY_GG: 'Γκέρνσεϊ',
    COUNTRY_GH: 'Γκάνα',
    COUNTRY_GI: 'Γιβραλτάρ',
    COUNTRY_GL: 'Γροιλανδία',
    COUNTRY_GM: 'Γκάμπια',
    COUNTRY_GN: 'Γκινέα',
    COUNTRY_GP: 'Γουαδελούπη',
    COUNTRY_GQ: 'Ισημερινή Γουινέα',
    COUNTRY_GR: 'Ελλάδα',
    COUNTRY_GS: 'Νότια Γεωργία',
    COUNTRY_GT: 'Γουατεμάλα',
    COUNTRY_GU: 'Γκουάμ',
    COUNTRY_GW: 'Γουινέα Μπισσάου',
    COUNTRY_GY: 'Γουιάνα',
    COUNTRY_HK: 'Χονγκ Κονγκ',
    COUNTRY_HM: 'Ακρόαση και νησιά McDonald',
    COUNTRY_HN: 'Ονδούρα',
    COUNTRY_HR: 'Κροατία',
    COUNTRY_HT: 'Αΐτη',
    COUNTRY_HU: 'Ουγγαρία',
    COUNTRY_ID: 'Ινδονησία',
    COUNTRY_IE: 'Αντιπροσωπεία της Ιρλανδίας',
    COUNTRY_IL: 'Ισραήλ',
    COUNTRY_IM: 'Νήσος του Μαν',
    COUNTRY_IN: 'Ινδία',
    COUNTRY_IO: 'Βρετανικό έδαφος του Ινδικού Ωκεανού',
    COUNTRY_IQ: 'Ιράκ',
    COUNTRY_IR: 'Ιράν',
    COUNTRY_IS: 'Ισλανδία',
    COUNTRY_IT: 'Ιταλία',
    COUNTRY_JE: 'Φανέλα',
    COUNTRY_JM: 'Ιαμαϊκή',
    COUNTRY_JO: 'Ιορδανία',
    COUNTRY_JP: 'Ιαπωνία',
    COUNTRY_KE: 'Κενύα',
    COUNTRY_KG: 'Κιργιζιστάν',
    COUNTRY_KH: 'Καμπότζη',
    COUNTRY_KI: 'Κιριμπάτι',
    COUNTRY_KM: 'Κομόρες',
    COUNTRY_KN: 'Άγιος Χριστόφορος και Νέβις',
    COUNTRY_KP: 'Βόρεια Κορέα',
    COUNTRY_KR: 'Νότια Κορέα',
    COUNTRY_KW: 'Κουβέιτ',
    COUNTRY_KY: 'Νησιά του Καϋμάν',
    COUNTRY_KZ: 'Καζακστάν',
    COUNTRY_LA: 'Λάος',
    COUNTRY_LB: 'Λίβανος',
    COUNTRY_LC: 'Αγία Λουκία',
    COUNTRY_LI: 'Λιχτενστάιν',
    COUNTRY_LK: 'Σρι Λάνκα',
    COUNTRY_LR: 'Λιβερία',
    COUNTRY_LS: 'Λεσότο',
    COUNTRY_LT: 'Λιθουανία',
    COUNTRY_LU: 'Λουξεμβούργο',
    COUNTRY_LV: 'Λετονία',
    COUNTRY_LY: 'Λιβύη',
    COUNTRY_MA: 'Μαρόκο',
    COUNTRY_MC: 'Μονακό',
    COUNTRY_MD: 'Μολδαβία',
    COUNTRY_ME: 'Μαυροβούνιο',
    COUNTRY_MG: 'Μαδαγασκάρη',
    COUNTRY_MH: 'Νήσοι Μάρσαλ',
    COUNTRY_MK: 'Δημοκρατία της Βόρειας Μακεδονίας',
    COUNTRY_ML: 'Μάλι',
    COUNTRY_MM: 'Μυανμάρ',
    COUNTRY_MN: 'Μογγολία',
    COUNTRY_MO: 'Μακάο',
    COUNTRY_MP: 'Βορεια Νησια Μαριανα',
    COUNTRY_MQ: 'Μαρτινίκα',
    COUNTRY_MR: 'Μαυριτανία',
    COUNTRY_MS: 'Montserrat',
    COUNTRY_MT: 'Μάλτα',
    COUNTRY_MU: 'Μαυρίκιος',
    COUNTRY_MV: 'Μαλδίβες',
    COUNTRY_MW: 'Μαλάουι',
    COUNTRY_MX: 'Μεξικό',
    COUNTRY_MY: 'Μαλαισία',
    COUNTRY_MZ: 'Μοζαμβίκη',
    COUNTRY_NA: 'Ναμίμπια',
    COUNTRY_NC: 'Νέα Καληδονία',
    COUNTRY_NE: 'Νίγηρα',
    COUNTRY_NF: 'Νησί Νόρφολκ',
    COUNTRY_NG: 'Νιγηρία',
    COUNTRY_NI: 'Νικαράγουα',
    COUNTRY_NL: 'Ολλανδία',
    COUNTRY_NO: 'Νορβηγία',
    COUNTRY_NP: 'Νεπάλ',
    COUNTRY_NR: 'Ναουρού',
    COUNTRY_NU: 'Νίουε',
    COUNTRY_NZ: 'Νέα Ζηλανδία',
    COUNTRY_OM: 'Ομάν',
    COUNTRY_PA: 'Παναμάς',
    COUNTRY_PE: 'Περού',
    COUNTRY_PF: 'Γαλλική Πολυνησία',
    COUNTRY_PG: 'Παπούα Νέα Γουινέα',
    COUNTRY_PH: 'Φιλιππίνες',
    COUNTRY_PK: 'Πακιστάν',
    COUNTRY_PL: 'Πολωνία',
    COUNTRY_PM: 'Σαιντ Πιέρ και Μικελόν',
    COUNTRY_PN: 'Πίτκαιρν',
    COUNTRY_PR: 'Πουέρτο Ρίκο',
    COUNTRY_PS: 'Παλαιστινιακά εδάφη',
    COUNTRY_PT: 'Πορτογαλία',
    COUNTRY_PW: 'Παλάου',
    COUNTRY_PY: 'Παραγουάη',
    COUNTRY_QA: 'Κατάρ',
    COUNTRY_RE: 'Επανένωση',
    COUNTRY_RO: 'Ρουμανία',
    COUNTRY_RS: 'Σερβία',
    COUNTRY_RU: 'Ρωσία',
    COUNTRY_RW: 'Ρουάντα',
    COUNTRY_SA: 'Σαουδική Αραβία',
    COUNTRY_SB: 'Νησιά του Σολομώντα',
    COUNTRY_SC: 'Σεϋχέλλες',
    COUNTRY_SD: 'Σουδάν',
    COUNTRY_SE: 'Σουηδία',
    COUNTRY_SG: 'Σιγκαπούρη',
    COUNTRY_SH: 'Αγία Ελένη',
    COUNTRY_SI: 'Σλοβενία',
    COUNTRY_SJ: 'Σβάλμπαρντ και Γιαν Μάγεν',
    COUNTRY_SK: 'Σλοβακία',
    COUNTRY_SL: 'Σιέρρα Λεόνε',
    COUNTRY_SM: 'Σαν Μαρίνο',
    COUNTRY_SN: 'Σενεγάλη',
    COUNTRY_SO: 'Σομαλία',
    COUNTRY_SR: 'Σουρινάμ',
    COUNTRY_ST: 'Σάο Τομέ και Πρίνσιπε',
    COUNTRY_SV: 'Ελ Σαλβαδόρ',
    COUNTRY_SY: 'Συρία',
    COUNTRY_SZ: 'Σουαζιλάνδη',
    COUNTRY_TA: 'Τριστάν ντα Κούνια',
    COUNTRY_TC: 'Νήσοι Τερκς και Κάικος',
    COUNTRY_TD: 'Τσαντ',
    COUNTRY_TF: 'Γαλλικά νότια εδάφη',
    COUNTRY_TG: 'Τόγκο',
    COUNTRY_TH: 'Ταϊλάνδη',
    COUNTRY_TJ: 'Τατζικιστάν',
    COUNTRY_TK: 'Τοκελάου',
    COUNTRY_TM: 'Τουρκμενιστάν',
    COUNTRY_TN: 'Τυνησία',
    COUNTRY_TO: 'Τόνγκα',
    COUNTRY_TP: 'Ανατολικό Τιμόρ',
    COUNTRY_TR: 'Τουρκία',
    COUNTRY_TT: 'Τρινιντάντ και Τομπάγκο',
    COUNTRY_TV: 'Τουβαλού',
    COUNTRY_TW: 'Ταϊβάν',
    COUNTRY_TZ: 'Τανζανία',
    COUNTRY_UA: 'Ουκρανία',
    COUNTRY_UG: 'Ουγκάντα',
    COUNTRY_UK: 'Ηνωμένο Βασίλειο',
    COUNTRY_UM: 'Μικροί απομακρυσμένοι νήσοι ΗΠΑ',
    COUNTRY_US: 'ΗΠΑ',
    COUNTRY_UY: 'Ουρουγουάη',
    COUNTRY_UZ: 'Ουζμπεκιστάν',
    COUNTRY_VA: 'Βατικάνο',
    COUNTRY_VC: 'Άγιος Βικέντιος και Γρεναδίνες',
    COUNTRY_VE: 'Βενεζουέλα',
    COUNTRY_VG: 'Βρετανικά Παρθένα νησιά',
    COUNTRY_VI: 'Παρθένα νησιά (ΗΠΑ)',
    COUNTRY_VN: 'Βιετνάμ',
    COUNTRY_VU: 'Βανουάτου',
    COUNTRY_WE: 'Δυτική Σαμόα',
    COUNTRY_WF: 'Νήσοι Ουαλίς και Φουτουνά',
    COUNTRY_WS: 'Σαμόα',
    COUNTRY_YE: 'Γέμενη',
    COUNTRY_YT: 'Μαγιότ',
    COUNTRY_ZA: 'Νότια Αφρική',
    COUNTRY_ZM: 'Ζάμπια',
    COUNTRY_ZW: 'Ζιμπάμπουε'
  },
  'ui-kit': uiKit,
  date: {
    today: 'Σήμερα',
    months: {
      JAN: uiKit.datepicker.january,
      FEB: uiKit.datepicker.february,
      MAR: uiKit.datepicker.march,
      APR: uiKit.datepicker.april,
      MAY: uiKit.datepicker.may,
      JUN: uiKit.datepicker.june,
      JUL: uiKit.datepicker.july,
      AUG: uiKit.datepicker.august,
      SEP: uiKit.datepicker.september,
      OCT: uiKit.datepicker.october,
      NOV: uiKit.datepicker.november,
      DEC: uiKit.datepicker.december
    },
    monthsNumbered: {
      '01': uiKit.datepicker.january,
      '02': uiKit.datepicker.february,
      '03': uiKit.datepicker.march,
      '04': uiKit.datepicker.april,
      '05': uiKit.datepicker.may,
      '06': uiKit.datepicker.june,
      '07': uiKit.datepicker.july,
      '08': uiKit.datepicker.august,
      '09': uiKit.datepicker.september,
      10: uiKit.datepicker.october,
      11: uiKit.datepicker.november,
      12: uiKit.datepicker.december
    }
  }
};